module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/6e7cebe5c1d0af6a3b6fd9f0b14cd79c.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/bronze.png
// module id = md6y
// module chunks = 0